<template>
  <v-card>
    <v-card-title>Insights Status Summary</v-card-title>
    <v-card-text>
      <div v-if="cached">
        <!-- <p>Cached: {{ cached }} </p>-->
        <div v-if="report">
          <p>Query queued for {{ Math.round(report.details.QueryExecution.Statistics.QueryQueueTimeInMillis / 1000) }}
            sec then took {{ Math.round(report.details.QueryExecution.Statistics.TotalExecutionTimeInMillis / 1000) }}
            sec
            to execute processing {{
              Math.round(report.details.QueryExecution.Statistics.DataScannedInBytes / 1000000)
            }} MB of data
            (approx. {{ (report.details.QueryExecution.Statistics.DataScannedInBytes / 1000000000).toFixed(2) }}
            GB) </p>
        </div>
      </div>
      <div v-if="!cached">
        <p>No cached report data</p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'insightreportstatuspanel',
  props: ['cached'],
  data: () => {
    return {}
  },
  computed: mapState({
    report: function () {
      return this.cached.report
    }
  })
}
</script>
